import { Route } from '@angular/router';
import { LoadProfilePermissions } from '@backoffice/shared/bo/util-permissions';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const normCubicMeterRoutes: Route = {
  path: 'norm-cubic-meters',
  loadComponent: () =>
    import('./norm-cubic-meter-list.component').then(
      (mod) => mod.NormCubicMeterListComponent,
    ),
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('../norm-cubic-meter-form/norm-cubic-meter-form.component').then(
          (mod) => mod.NormCubicMeterFormComponent,
        ),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
  canActivate: [ngxPermissionsGuard],
  data: {
    translate: 'settings.norm-cubic-meter',
    permissions: {
      only: LoadProfilePermissions.edit,
    },
  },
};
